




















































import { Component } from "vue-property-decorator";

import { DialogSection, DialogForm, FormText } from "sitewhere-ide-components";
import { VFlex } from "vuetify/lib";

import { IRabbitMqConfiguration } from "sitewhere-configuration-model";
import { required } from "vuelidate/lib/validators";

@Component({
  components: { DialogForm, FormText, VFlex },
  validations: {
    connectionUri: {
      required
    },
    queueName: {
      required
    },
    numConsumers: {
      required
    },
    reconnectInterval: {
      required
    }
  }
})
export default class RabbitMqFields extends DialogSection {
  connectionUri = "";
  queueName = "";
  numConsumers = 5;
  reconnectInterval = 10;

  /** Reset section content */
  reset(): void {
    this.connectionUri = "";
    this.queueName = "";
    this.numConsumers = 5;
    this.reconnectInterval = 10;
    this.$v.$reset();
  }

  /** Perform validation */
  validate(): boolean {
    this.$v.$touch();
    return !this.$v.$invalid;
  }

  /** Load form data from an object */
  load(input: IRabbitMqConfiguration): void {
    this.connectionUri = input.connectionUri || "";
    this.queueName = input.queueName || "";
    this.numConsumers = input.numConsumers || 5;
    this.reconnectInterval = input.reconnectInterval || 10;
  }

  /** Save form data to an object */
  save(): {} {
    return {
      connectionUri: this.connectionUri,
      queueName: this.queueName,
      numConsumers: this.numConsumers,
      reconnectInterval: this.reconnectInterval
    };
  }
}
